import React, { useState, useEffect } from 'react';
import { DragFilledIcon } from '../Icons';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTheme } from "@hooks/useTheme";
import { get_policy_attributes } from '../../constants/licensePolicy';
import { useTranslation } from 'react-i18next';

const AttributeItem = ({ 
  attribute, 
  onDragStart, 
  showDelete = false, 
  onDelete,
  isInStep = false
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const policyAttributes = get_policy_attributes(t);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1760);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1760);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(attribute);
    }
  };

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, attribute)}
      className={`flex items-center rounded border ${colors.borderPolicyAttribute} cursor-move hover:shadow-md transition-all overflow-hidden min-h-10 max-h-12`}
    >
      {/* Left part - Drag handle and Attribute code */}
      <div className={`flex items-center gap-3 p-2 ${colors.bgPolicyAttributeItemLeftSide} hover:opacity-80 transition-colors min-[1760px]:w-44 w-34 h-12 flex-shrink-0`}>
        {/* Drag handle */}
        <DragFilledIcon size={8} className={colors.textSubTitle} />
        
        {/* Attribute code */}
        <div className={`${colors.textNormal} min-[1760px]:text-sm text-[10px] min-w-fit`}>
           {t(`license-policy.g_attributes.${attribute.code}.name`)}
        </div>
      </div>
      
      {/* Right part - Attribute description */}
      <div className={`flex-1 flex items-center justify-between p-2 ${colors.bgPolicyAttributeItemRightSide} hover:opacity-80 transition-colors h-12 min-w-0`}>
        <div className={`${colors.textSubTitle} text-[10px] min-[1760px]:text-sm break-words ${isInStep ? 'max-w-[calc(100%-40px)]' : ''}`}>
          {isInStep
            ? t(`license-policy.g_attributes.${attribute.licensePolicyCd || attribute.code}.remark`)
            : (isLargeScreen
              ? t(`license-policy.g_attributes.${attribute.licensePolicyCd || attribute.code}.remark`)
              : truncateText(t(`license-policy.g_attributes.${attribute.licensePolicyCd || attribute.code}.remark`))
            )
          }
        </div>
        
        {/* Delete icon */}
        {showDelete && (
          <button
            onClick={handleDelete}
            className={`ml-3 p-1 hover:opacity-70 rounded transition-colors ${colors.textSecondary} flex-shrink-0`}
            title="Remove attribute"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default AttributeItem; 